import MuiMenu from "@mui/material/Menu";

import { styled } from "@mui/material";

export const Menu = styled(MuiMenu)(() => ({
  padding: 0,
  width: "260px",

  "& .MuiMenu-paper": {
    width: "260px",

    padding: "8px 0 8px",
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.05))",
  },

  "& .MuiMenu-list": {
    padding: 0,
  },
}));
